import { render, staticRenderFns } from "./LoadingDialogue.vue?vue&type=template&id=125d4897&"
import script from "./LoadingDialogue.vue?vue&type=script&lang=js&"
export * from "./LoadingDialogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports